import { getUser, getCooperationType } from '@/services/auth/utils'

// 双师购课权限
export function newPurchase () {
  return getUser('permissions').indexOf('ms_new_purchase') !== -1
}

// 双师家长端购买权限或教务报名缴费
export function enrollCharge () {
  return getUser('permissions').indexOf('enroll_charge') !== -1 || getUser('permissions').indexOf('academic_charge') !== -1
}

export function validateOnlyContent () {
  let cooperationTypes = getCooperationType()
  return cooperationTypes && cooperationTypes.ms_content && !cooperationTypes.ms_ai && !cooperationTypes.ms_ss
}
export default {
  newPurchase,
  enrollCharge,
  validateOnlyContent
}
